import Select from "react-select";
import { useContext, useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";

import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import TooltipTitle from "../../../utils/TooltipTitle/TooltipTitle";
import CustomModal from "../../../utils/CustomModal/CustomModal";
import ParamsOperator from "./ParamsOperator/ParamsOperator";
import { serviceAdminContext } from "../../../context/Admin/ServiceAdminContext/ServiceAdminContext";
import {
  displayModeItems,
  displayModeToText,
  numberSeparate,
  serviceParameters,
} from "../../../utils";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";

const ServiceAdmin = () => {
  const permission = useSelector((state) => state.permission);
  const appConfigs = useSelector((state) => state.appConfigs);
  const cities = useSelector((state) => state.cities);

  const [displayMode, setDisplayMode] = useState(displayModeItems[1]);

  const {
    services,
    service,
    categories,
    added_cities,
    setAdded_cities,
    search,
    setSearch,
    step,
    setStep,
    categoryId,
    setCategoryId,
    isShowModal,
    unique_id,
    setUnique_id,
    name,
    setName,
    description,
    setDescription,
    price,
    setPrice,
    setService_category_name,
    poster,
    setPoster,
    icon,
    setIcon,
    has_discount,
    setHas_discount,
    is_active,
    setIs_active,
    always_discount,
    setAlways_discount,
    special,
    setSpecial,
    service_category_id,
    setService_category_id,
    isEdit,
    isShowEditParamModal,
    parameterType,
    setParameterType,
    handleShowEditParamModal,
    handleCloseEditParamModal,
    handleShowModal,
    handleCloseModal,
    handleGetServices,
    handleDeleteService,
    handleGetCategories,
    handleCreateService,
    handleGetService,
    handleEditService,
    handleAddParam,
    handleEditParamsService,
  } = useContext(serviceAdminContext);

  useEffect(() => {
    handleGetCategories();
  }, []);

  useEffect(() => {
    handleGetServices();
  }, [categoryId]);

  useEffect(() => {
    // Set Category name to state
    if (service_category_id) {
      const cat = categories.find((c) => c.id === service_category_id);
      setService_category_name(cat.name);
    }
  }, [service_category_id]);

  return (
    <>
      <SiteTitle title="خدمات" />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: "خدمات", type: "a" },
        ]}
        title="لیست خدمات"
      />

      <CardLayout>
        {permission.moderator_create_update && (
          <div className="mb-2">
            <button
              className="btn btn-success"
              onClick={() => handleShowModal()}
            >
              <i className="fa fa-plus mr-2" />
              افزودن
            </button>
          </div>
        )}
        <div>
          <form className="input-group mb-3" onSubmit={handleGetServices}>
            <div className="input-group-prepend">
              <TooltipTitle title="دسته بندی" placement="bottom">
                <select
                  className="form-control"
                  name="type"
                  defaultValue=""
                  onChange={(e) =>
                    setCategoryId(
                      e.target.value ? Number(e.target.value) : null
                    )
                  }
                >
                  <option selected value="">
                    دسته بندی: همه
                  </option>
                  {categories?.map((_value) => (
                    <option
                      key={_value?.id}
                      selected={_value?.id === categoryId}
                      value={_value?.id}
                    >
                      {_value?.name}
                    </option>
                  ))}
                </select>
              </TooltipTitle>
            </div>
            <input
              type="text"
              name="search"
              autoComplete="off"
              placeholder="جستجو ..."
              className="form-control"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <div className="input-group-append">
              <button type="submit" className="btn btn-primary">
                جستجو
              </button>
            </div>
          </form>
          <div className="d-flex align-items-center justify-content-end my-2">
            <span>نحوه نمایش:</span>
            <div>
              {displayModeItems.map((item) => (
                <button
                  key={item}
                  className={`ml-2 btn btn-${
                    displayMode === item ? "info" : "white border"
                  }`}
                  onClick={() => setDisplayMode(item)}
                >
                  {displayModeToText(item)}
                </button>
              ))}
            </div>
          </div>
        </div>

        {isEmpty(services) ? (
          <EmptyData />
        ) : (
          <>
            {displayMode === displayModeItems[0] ? (
              <Table responsive hover borderless striped>
                <thead className="thead-dark">
                  <tr>
                    <th>#</th>
                    <th>شناسه</th>
                    <th>نام</th>
                    <th>تکرار سفارش</th>
                    <th className="text-center" />
                  </tr>
                </thead>
                <tbody>
                  {services.map((_item, index) => (
                    <tr key={_item.unique_id + index}>
                      <td>{index + 1}</td>
                      <td>{_item.unique_id}</td>
                      <td>{_item.name}</td>
                      <td>{numberSeparate(_item.repetition)}</td>
                      <td className="mw-25">
                        {permission.moderator_create_update && (
                          <button
                            onClick={() =>
                              handleGetService(
                                _item?.unique_id,
                                handleShowEditParamModal
                              )
                            }
                            className="btn btn-success mr-2"
                          >
                            افزودن / ویرایش پارامتر
                          </button>
                        )}
                        {permission.moderator_create_update && (
                          <button
                            onClick={() =>
                              handleGetService(
                                _item?.unique_id,
                                handleShowModal
                              )
                            }
                            className="btn btn-primary mr-2"
                          >
                            ویرایش
                          </button>
                        )}
                        {permission.moderator_delete && (
                          <i
                            onClick={() =>
                              areYouSureMessage(
                                () => handleDeleteService(_item.unique_id),
                                `آیا از حذف خدمت ${_item?.name} اطمینان دارید؟`
                              )
                            }
                            className="fa fa-trash-alt fa-2x text-danger cursorPointer"
                          />
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : displayMode === displayModeItems[1] ? (
              <>
                {!categoryId ? (
                  <div className="row justify-content-center mx-0">
                    {categories?.map((_item, index) => (
                      <div className="col-auto my-2 px-1" key={index}>
                        <span
                          className="cursorPointer"
                          onClick={() => setCategoryId(_item?.id)}
                        >
                          <img
                            key={_item?.id}
                            src={`${appConfigs.APP_DOWNLOAD_LINK}static/console/${_item.icon}.png`}
                            alt={_item.name}
                            width="130"
                            height="130"
                          />
                        </span>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="row justify-content-center align-items-center">
                    {services.map((_item, index) => (
                      <div className="col-auto my-3" key={index}>
                        <span
                          className="cursorPointer"
                          onClick={() =>
                            permission.moderator_create_update &&
                            handleGetService(_item?.unique_id, handleShowModal)
                          }
                        >
                          <img
                            key={_item?.unique_id}
                            src={`${appConfigs.APP_DOWNLOAD_LINK}static/console/services/${_item.icon}`}
                            alt={_item.name}
                            width="160"
                            height="160"
                            className="p-2 p-sm-0"
                          />
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </>
            ) : null}
          </>
        )}
      </CardLayout>

      {/* Start Create Modal */}
      <CustomModal
        title={`${isEdit ? "ویرایش" : "افزودن"} خدمت`}
        show={isShowModal}
        onHide={handleCloseModal}
        size="xl"
      >
        <form
          onSubmit={isEdit ? handleEditService : handleCreateService}
          autoComplete="off"
        >
          <div className="row">
            <div className="col-12 mb-2">
              <label htmlFor="name">نام خدمت</label>
              <input
                type="text"
                id="name"
                name="name"
                className="form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="unique_id">کد دوحرفی یکتا</label>
              <input
                type="text"
                id="unique_id"
                min={2}
                max={2}
                name="unique_id"
                className={`form-control ${isEdit ? "bg-light" : ""}`}
                value={unique_id}
                disabled={isEdit}
                readOnly={isEdit}
                onChange={(e) => setUnique_id(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="price">تعرفه</label>
              <input
                type="number"
                id="price"
                name="price"
                className="form-control"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="name">دسته بندی</label>
              <select
                className="form-control"
                name="type"
                onChange={(e) =>
                  setService_category_id(
                    e.target.value ? Number(e.target.value) : null
                  )
                }
              >
                <option selected disabled hidden>
                  لطفا دسته بندی خدمت را انتخاب کنید
                </option>
                {categories?.map((_value) => (
                  <option
                    key={_value?.id}
                    id={_value?.name}
                    selected={_value?.id === service_category_id}
                    value={_value?.id}
                  >
                    {_value?.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="poster">پوستر خدمات</label>
              <input
                type="text"
                id="poster"
                name="poster"
                className="form-control"
                value={poster}
                onChange={(e) => setPoster(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="icon">آیکن</label>
              <input
                type="text"
                id="icon"
                name="icon"
                className="form-control"
                value={icon}
                onChange={(e) => setIcon(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="repetition">تکرار سفارش</label>
              <input
                type="text"
                id="repetition"
                name="repetition"
                className="form-control bg-light"
                value={numberSeparate(service.repetition)}
                disabled
                readOnly
              />
            </div>
            <div className="col-12 mb-2">
              <label htmlFor="cities">شهر</label>
              <Select
                options={cities}
                value={added_cities}
                placeholder="شهر ها را انتخاب کنید"
                isMulti
                name="cities"
                onChange={setAdded_cities}
              />
            </div>
            <div className="col-6 col-lg-3 mb-2">
              <div className="custom-control custom-switch mb-2">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="is_active"
                  checked={is_active}
                  onChange={(e) => setIs_active(e.target.checked)}
                />
                <label className="custom-control-label" for="is_active">
                  فعال
                </label>
              </div>
            </div>
            <div className="col-6 col-lg-3 mb-2">
              <div className="custom-control custom-switch mb-2">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="always_discount"
                  checked={always_discount}
                  onChange={(e) => setAlways_discount(e.target.checked)}
                />
                <label className="custom-control-label" for="always_discount">
                  همیشه تخفیف
                </label>
              </div>
            </div>
            <div className="col-6 col-lg-3 mb-2">
              <div className="custom-control custom-switch mb-2">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="special"
                  checked={special}
                  onChange={(e) => setSpecial(e.target.checked)}
                />
                <label className="custom-control-label" for="special">
                  پیام خاص
                </label>
              </div>
            </div>
            <div className="col-6 col-lg-3 mb-2">
              <div className="custom-control custom-switch mb-2">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="has_discount"
                  checked={has_discount}
                  onChange={(e) => setHas_discount(e.target.checked)}
                />
                <label className="custom-control-label" for="has_discount">
                  کد تخفیف
                </label>
              </div>
            </div>
            <div className="col-12 mb-2">
              <label htmlFor="description">توضیحات</label>
              <textarea
                type="text"
                id="description"
                name="description"
                className="form-control"
                value={description}
                rows={7}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </div>

          <hr />
          <button className="btn btn-primary" type="submit">
            <i className="fas fa-check mr-2"></i>
            {isEdit ? "ویرایش" : "افزودن"}
          </button>

          {isEdit && (
            <>
              {permission.moderator_delete && (
                <button
                  onClick={() =>
                    areYouSureMessage(
                      () => handleDeleteService(unique_id),
                      `آیا از حذف خدمت ${name} اطمینان دارید؟`
                    )
                  }
                  className="btn btn-danger ml-2"
                  type="button"
                >
                  <i className="fas fa-trash mr-2" /> حذف
                </button>
              )}
              <button
                onClick={() =>
                  handleGetService(unique_id, handleShowEditParamModal)
                }
                className="btn btn-success ml-2"
                type="button"
              >
                افزودن / ویرایش پارامتر
              </button>
            </>
          )}
        </form>
      </CustomModal>
      {/* End Create Modal */}

      {/* Start Edit Params Modal */}
      <CustomModal
        title="افزودن / ویرایش پارامتر"
        show={isShowEditParamModal}
        onHide={handleCloseEditParamModal}
        size="xl"
      >
        <form
          onSubmit={(e) => handleAddParam(e, null, setStep)}
          autoComplete="off"
        >
          <div className="row align-items-end">
            <div className="col-10 mb-2">
              <label htmlFor="name">نوع پارامتر</label>
              <select
                className="form-control"
                name="type"
                onChange={(e) => setParameterType(Number(e.target.value))}
              >
                <option selected disabled hidden>
                  لطفا نوع پارامتر را انتخاب کنید
                </option>
                {serviceParameters?.map((_value, index) => (
                  <option
                    key={index}
                    selected={index === parameterType}
                    value={index}
                  >
                    {_value}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-2 mb-2">
              <button className="btn btn-success btn-block" type="submit">
                <i className="fas fa-check mr-2"></i>
                افزودن
              </button>
            </div>
          </div>
        </form>
        <hr />
        <ParamsOperator step={step} setStep={setStep} />
        <button
          className="btn btn-primary btn-block"
          onClick={handleEditParamsService}
          type="submit"
        >
          <i className="fas fa-check mr-2"></i>
          ویرایش
        </button>
      </CustomModal>
      {/* End Add Params Modal */}
    </>
  );
};

export default ServiceAdmin;
